import { render } from "./person-model.vue?vue&type=template&id=17f0ca56&scoped=true"
import script from "./person-model.vue?vue&type=script&lang=ts"
export * from "./person-model.vue?vue&type=script&lang=ts"

import "./person-model.vue?vue&type=style&index=0&id=17f0ca56&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-17f0ca56"

export default script